<template>
    <span>
        <select :value="value" @change="onChange">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
        </select>
    </span>
</template>

<script>
    export default {
        props: {
            value: {
                type: Number,
                required: true
            }
        },
        methods: {
            onChange(e) {
                this.$emit('select', e.target.value);
            }
        }
    }
</script>

<style scoped lang="scss">
    select {
        border: none;
        font-size: 14px;
    }
</style>
